import React, { lazy, Suspense } from 'react'

const DatePickerInput = lazy(() => import(/* webpackChunkName: "datepicker" */ './DatePickerInput'))

const Input = (props) => {
    let input = ''

    //Check out the validation
    const errors = (props.validation && props.validation.isValid === false)
        ? props.validation.errors.map((error, i) => (<li key={i}>{`${error} `}</li>))
        : []

    //Get rid of validation object, we don't need it in html inputs etc.
    let { validation, options, ...newProps } = props

    switch (props.type) {
        case 'text':
        case 'password':
        case 'number':
        case 'email':
        case 'search':
            input = (
                <div className='form-floating'>
                    <input {...newProps} className={`form-control ${!validation.isValid ? 'is-invalid' : ''}`} />
                    <label>{newProps.placeholder}</label>
                </div>
            )
            break
        case 'textarea':
            input = <textarea {...newProps} rows={props.rows} cols={props.cols} className='form-control' />
            break
        case 'checkbox':
            input = (
                <div className={`${!validation.isValid ? 'has-error' : ''}`}>
                    <input {...newProps} />
                    <label htmlFor={props.name}><span>{props.label}</span></label>
                </div>
            )
            break
        case 'radio':
            input = (
                <div className="special-select__container">
                    {props.options ? props.options.map((option, index) => (
                        <label key={option.name + index} className="special-radio__container">
                            <div dangerouslySetInnerHTML={{ __html: option.name }}></div>
                            <input {...newProps} id={newProps.id + index} type='radio' name={props.name} value={option.value} checked={props.value == option.value} />
                            <span className="special-radio__checkmark"></span>
                        </label>
                    )) : null}
                </div>
            )
            break
        case 'select':
            input = (
                <div className="special-select__container">
                    <select {...newProps} className={`form-control ${!validation.isValid ? 'is-invalid' : ''} ${props.className}`} >
                        <option className="option-default" hidden={true}>{props.placeholder}</option>
                        {props.options ? props.options.map((option, index) => (
                            <option
                                key={option.name + index}
                                value={option.value}
                                disabled={option.disabled}
                                title={option.title}>{option.name}</option>
                        )) : null}
                    </select>
                    <span className="special-select__arrow icon icon-angle-down"></span>
                </div>
            )
            break
        case 'datepicker':
            input = (
                <Suspense fallback={<input type="text" className="form-control" disabled placeholder={props.placeholder} />}>
                    <DatePickerInput
                        value={props.value}
                        onChange={props.onChange}
                        placeholder={props.placeholder}
                        minage={props.minage}
                        maxage={props.maxage} />
                </Suspense>
            )
            break
        default: break
    }

    return (
        <div className={'form-group'}>
            <div className={'form-input'}>{input}</div>
            {errors.length ? <ul className={'form-error animation-fadein--delayed'}>{errors}</ul> : null}
        </div>
    )
}

export default Input
